import CourseCreationChecklist from './panels/course-creation-checklist';
import QuickActionsVM from '../../../instructor/gradebook/overview/quick-actions-vm';
import ForumConnectTab from '../../../common/forum_thread/embedded/module';
import GalleryConnectTab from '../../../common/coursework/gallery/overview/module';
import PendingEnrollmentsPanel from './panels/pending-enrollments';
export default {
  name: 'Dashboard',
  comments: true,
  data: {
    course: null,
    course_creation_progress: null,
    sessions: null,
    courseworks: null,
    pending_enrollments: null,
    submissions: null,
    showOnboardingModal: false
  },
  components: {
    CourseCreationChecklist,
    PendingEnrollmentsPanel
  },
  methods: {
    bindData(data) {
      this.showOnboardingModal = !data.onboarding_modal_shown;
      this.course = data.course;
      this.course_creation_progress = data.course_creation_progress;
      this.sessions = data.sessions;
      this.courseworks = data.courseworks;
      this.pending_enrollments = data.pending_enrollments;
      this.submissions = data.submissions;
    },
    triggerOnboarding() {
      $('.kd-panel--checklist').trigger('showTooltip');
    },
    onboardingTooltipParams() {
      return {
        arrow: true,
        position: 'bottom',
        showDelay: 0.5,
        template: 'templates/tooltips/instructor/course_dashboard/onboarding1',
        interactive: {
          context: `InstCourseDashOnboarding-${this.course.id}`,
          order: 1,
          end: true,
          overlay: true
        },
        eventIn: 'showTooltip',
        eventOut: null
      };
    }
  },
  mounted() {
    if (this.course.has_peer_entries)
      GalleryConnectTab.init($('#coursework-overview')[0])

    ForumConnectTab.init($('#conversations')[0])

    const quickActions = new QuickActionsVM()
    const qaElement = quickActions.$el[0]

    if (qaElement && !ko.dataFor(qaElement)) {
      ko.applyBindingsWithValidation(
        quickActions,
        qaElement,
        Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS
      )
    }

    if (this.course.isDraft)
      this.triggerOnboarding()
  }
};
